import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {Button, Col, Container, Row} from "reactstrap";
import {HasPermission} from "../HasPermission";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {IWindow} from "../../index";
import {LGAPicker} from "../form/fields/LGAPicker";
import {ToastContainer} from 'react-toastify';
import { toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
     
const qs = require('qs');

const IWindow: IWindow = (window as IWindow);

export class ElectionPollingUnitResultFormData {
    @observable user_level = IWindow.initialState.user.level;
    @observable party_competitor_party_result = 1;
    @observable election_id = null;
    @observable party_id = null;
    @observable candidate_id = null;
    @observable election_position_id = null;
	@observable obj_data_value = '';
    @observable number_of_votes  : number | null = null;
    @observable accredited_voters : number | null = null;
    @observable pu_registered_voters  : number | null = null;
    @observable disputed_voters  : number | null = null;
    @observable rejected_voters  : number | null = null;
    @observable user_defined_1  : number | null = null;
    @observable user_defined_2  : number | null = null;
    @observable verified_voters_from_cr  : number | null = null;
    @observable level = '';
    @observable state_id = '';
    @observable senatorial_district_id = '';
    @observable federal_constituency_id = '';
    @observable state_constituency_id = '';
    @observable local_government_area = null;
    @observable local_government_area_id = '';
    @observable ward_id = '';
    @observable election_polling_unit_id = null;
    
}

export class ElectionPollingUnitResultForm extends CrudForm {
    @observable registeredVoter  : any;
    modelName = 'ElectionPollingUnitResult';
    
    party_id = IWindow.initialState.user.party_id;
    @observable nofvotes = false;
    @observable avoters = false;
    @observable rvoters = false;
    @observable dvoters = false;
    @observable regvoters = false;

    constructor(props: any) {
        super(props);
        this.onKeyPress = this.onKeyPress.bind(this);
   }
   

     onKeyPress = (value: any) => {

        const validate = /^[0-9\b]+$/;
        if (!validate.test(value) && value) {
            this.formStore.setValue('number_of_votes', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('accredited_voters', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('pu_registered_voters', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('disputed_voters', Number(value.substring(0, value.length - 1)));
            this.formStore.setValue('rejected_voters', Number(value.substring(0, value.length - 1)));
            
        }

        if (this.formStore.getValue('rejected_voters') > this.registeredVoter) {
            // this.formStore.setValue('number_of_votes', Number(this.registeredVoter));
            if(!this.regvoters)
             toast.error('You are adding more than number of voters, kindly note that');
 
            this.regvoters = true;
                 
            
         }

        if (this.formStore.getValue('number_of_votes') > this.registeredVoter) {
           // this.formStore.setValue('number_of_votes', Number(this.registeredVoter));
           if(!this.nofvotes)
            toast.error('You are adding more than number of voters, kindly note that');

           this.nofvotes = true;
                
           
        }

        if (this.formStore.getValue('accredited_voters') > this.registeredVoter) {
           // this.formStore.setValue('accredited_voters', Number(this.registeredVoter));
           if(!this.avoters)
            toast.error('You are adding more than number of voters, kindly note that');

           this.avoters = true;
        }

        if (this.formStore.getValue('pu_registered_voters') > this.registeredVoter) {
          //  this.formStore.setValue('pu_registered_voters', Number(this.registeredVoter));
          if(!this.rvoters)
            toast.error('You are adding more than number of voters, kindly note that');

          this.rvoters = true;
        }

        if (this.formStore.getValue('disputed_voters') > this.registeredVoter) {
         //   this.formStore.setValue('disputed_voters', Number(this.registeredVoter));
         if(!this.dvoters)
            toast.error('You are adding more than number of voters, kindly note that');

         this.dvoters = true;
        }
    };
 

    loadMoreData(props: any, module: any) {
        if (Number(window.localStorage.getItem('election_id')) > 0) {
            this.formStore.setValue('election_id', Number(window.localStorage.getItem('election_id')));
            this.getPollingUnitByUserPollingUnitId();
        } else {
            this.formStore.setValue('election_id', null);
        }
    }

    getPollingUnitByUserPollingUnitId = () => {
        if(!IWindow.initialState.user.polling_unit_id || !this.formStore.getValue('election_id')){
           return;
        }
        api.electionPollingUnit.getListAction({
            page:0,
            filters: {
                polling_unit_id: IWindow.initialState.user.polling_unit_id,
                election_id: this.formStore.getValue('election_id')
            }
        }).then((data: any) => {
            if(data && data.length){
               this.formStore.setValue('election_polling_unit_id', data[0].id);
             }
        });

    };

    stateDropDown() {
        return (!(['senatorial_district', 'federal_constituency', 'state_constituency', 'polling_unit'])
            .includes(this.formStore.getValue('level'))) ?

            <Field
                key={"form_state_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                label="State"
                name="state_id"
                placeholder="Select State"
                component={Select}
                loadOptions={() => {
                    return api.state.getListAction({
                        filters: {
                            election_id: this.formStore.getValue('election_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={() => {
                    this.formStore.setValue('senatorial_district_id', null);
                    this.formStore.setValue('federal_constituency_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                    this.formStore.setValue('state_constituency_id', null);
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('election_polling_unit_id', null);
                }}
            /> : '';
    };

    senatorialDistrictDropDown() {
        return this.formStore.getValue('level') === 'senatorial_district' ?

            <Field
                key={"form_senatorial_district_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                label="Senatorial District"
                name="senatorial_district_id"
                placeholder="Select Senatorial Districts"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.senatorialDistrict.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                    this.formStore.setValue('election_polling_unit_id', null);
                }}
            /> : '';
    }

    federalConstituencyDropDown() {
        return this.formStore.getValue('level') === 'federal_constituency' ?
            <Field
                label="Federal Constituency"
                key={"form_federal_constituency_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                name="federal_constituency_id"
                placeholder="Select Federal Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.federalConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('local_government_area_id', null);
                    this.formStore.setValue('election_polling_unit_id', null);
                }}
            /> : '';
    }

    lgaDropDown() {
        return (!((['ward', 'state_constituency'])
            .includes(this.formStore.getValue('level')))  &&
        (this.formStore.getValue('state_id') ||
            this.formStore.getValue('senatorial_district_id') ||
            this.formStore.getValue('federal_constituency_id')
        ) ) ?
            <Field
                key={"form_local_government_area_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id') +
                this.formStore.getValue('state_id') +
                this.formStore.getValue('senatorial_district_id') +
                this.formStore.getValue('federal_constituency_id')
                }
                label={"LGA"}
                placeholder={"LGA"}
                name="local_government_area"
                store={this.formStore}
                multi={false}
                component={LGAPicker}
                returnObject={false}
                filters={{
                    election_id: this.formStore.getValue('election_id'),
                    state_id: this.formStore.getValue('state_id'),
                    senatorial_district_id: this.formStore.getValue('senatorial_district_id'),
                    federal_constituency_id: this.formStore.getValue('federal_constituency_id'),
                    election_position_id: this.formStore.getValue('election_position_id'),
                    level: this.formStore.getValue('level'),
                    candidateIds: [this.formStore.getValue('candidate_id')],
                    party_id: this.formStore.getValue('party_id'),
                    user_level: this.formStore.getValue('user_level'),
                }}
                onChange={(value: any) => {
                    if(value){
                        this.formStore.setValue('local_government_area_id', value.id);
                    }
                    this.formStore.setValue('ward_id', null);
                    this.formStore.setValue('election_polling_unit_id', null);
                }}

            /> : '';
    };

    stateConstituencyDropDown() {
        return this.formStore.getValue('level') === 'state_constituency' ?

            <Field
                label="State Constituency"
                key={"form_state_constituency_id_" +
                this.formStore.getValue('election_id') +
                this.formStore.getValue('party_id') +
                this.formStore.getValue('election_position_id') +
                this.formStore.getValue('level') +
                this.formStore.getValue('candidate_id')
                }
                name="state_constituency_id"
                placeholder="Select State Constituency"
                component={Select}
                valueObject={true}
                loadOptions={() => {
                    return api.stateConstituency.getListAction({
                        filters: {
                            state_id: this.formStore.getValue('state_id'),
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level'),
                            candidateIds: this.formStore.getValue('candidate_id') ?
                                [this.formStore.getValue('candidate_id')] : null,
                            party_id: this.formStore.getValue('party_id'),
                            user_level: this.formStore.getValue('user_level')
                        }
                    });
                }}
                store={this.formStore}
                onChange={(item: any) => {
                    this.formStore.setValue('ward_id', null);
                }}
            /> : '';
    }

    wardsDropDown() {
        return  (this.formStore.getValue('local_government_area_id') ||
            this.formStore.getValue('state_constituency_id') ||
            this.formStore.getValue('level') === 'polling_unit') ?

        <Field
            key={"form_ward_id_" +
            this.formStore.getValue('election_id') +
            this.formStore.getValue('party_id') +
            this.formStore.getValue('election_position_id') +
            this.formStore.getValue('level') +
            this.formStore.getValue('candidate_id') +
            this.formStore.getValue('state_id') +
            this.formStore.getValue('senatorial_district_id') +
            this.formStore.getValue('federal_constituency_id') +
            this.formStore.getValue('state_constituency_id') +
            this.formStore.getValue('local_government_area_id')
            }
            label="Ward"
            name="ward_id"
            placeholder="Select Ward"
            component={Select}
            loadOptions = { () => {
                return api.ward.getListAction({
                    filters : {
                        state_id: this.formStore.getValue('state_id'),
                        local_government_area_id: this.formStore.getValue('local_government_area_id'),
                        state_constituency_id: this.formStore.getValue('state_constituency_id'),
                        election_position_id: this.formStore.getValue('election_position_id'),
                        level: this.formStore.getValue('level'),
                        candidateIds: [this.formStore.getValue('candidate_id')],
                        party_id: this.formStore.getValue('party_id'),
                        user_level: this.formStore.getValue('user_level'),
                        no_position: (this.formStore.getValue('level') === 'polling_unit') ? 1 : null,
                    }
                });
            }}
            store={this.formStore}
            onChange={() => {
                this.formStore.setValue('election_polling_unit_id', null);
            }}
        /> : ''
    }

    renderFields() {
        return (
            <>
                <Field
                    key={"form-field-election-id"}
                    placeholder="Select Election"
                    name="election_id"
                    component={Select}
                    required={true}
                    loadOptions={api.election.getListAction}
                    store={this.formStore}
                    onChange={() => {
                        this.getPollingUnitByUserPollingUnitId();
                        this.formStore.setValue('party_id', null);
                        this.formStore.setValue('candidate_id', null);
                    }}
                />

                {this.formStore.getValue('election_id') ?

                    <Field
                        key={'form_party_id_' + this.formStore.getValue('election_id')}
                        name="party_id"
                        placeholder="Select Party"
                        component={Select}
                        disabled={!this.formStore.getValue('election_id')}
                        required={true}
                        loadOptions={() => {
                            return api.party.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    include_competitor_party: 1
                                }
                            }).then((data: any) => {
                                return data.data;
                            });
                        }}
                        store={this.formStore}
                        onChange={() => {
                            this.formStore.setValue('candidate_id', null);
                            //this.formStore.setValue('election_position_id', null);
                        }}
                    /> : ''
                }

                {this.formStore.getValue('election_id') ?

                    <Field
                        key={'form_election_position_id_' + this.formStore.getValue('election_id') + this.formStore.getValue('party_id')}
                        name="election_position_id"
                        placeholder="Select Position"
                        component={Select}
                        disabled={!this.formStore.getValue('election_id')}
                        required={true}
                        loadOptions={() => {
                            return api.electionPosition.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    other_party_id: (this.party_id != this.formStore.getValue('party_id') ?
                                        this.formStore.getValue('party_id') : null),
                                    party_id: this.party_id
                                }
                            });
                        }}
                        returnObject={true}
                        extraKey={'level'} 
                        store={this.formStore}
                        onChange={(item: any) => {
                            this.formStore.setValue('level', null);
                            if (item) {
                                this.formStore.setValue('level', item.extraKey);
                            }
                            this.formStore.setValue('candidate_id', null);
                            this.formStore.setValue('state_id', null);
                            this.formStore.setValue('senatorial_district_id', null);
                            this.formStore.setValue('federal_constituency_id', null);
                            this.formStore.setValue('local_government_area_id', null);
                            this.formStore.setValue('state_constituency_id', null);
                            this.formStore.setValue('ward_id', null);
                        }}
                    />
                    : ''
                }

                {this.formStore.getValue('party_id') && this.formStore.getValue('election_id') ?

                    <Field
                        key={'form_candidate_filter_election_result_' +
                        this.formStore.getValue('party_id') + '_election_id' +
                        this.formStore.getValue('election_id') + '_election_position_id' +
                        this.formStore.getValue('election_position_id')}
                        name="candidate_id"
                        placeholder="Select Candidate"
                        component={Select}
                        disabled={!this.formStore.getValue('party_id')}
                        required={true}
                        loadOptions={() => {
                            return api.candidate.getListAction({
                                filters: {
                                    election_id: this.formStore.getValue('election_id'),
                                    party_id: this.formStore.getValue('party_id'),
                                    election_position_id: this.formStore.getValue('election_position_id'),
                                }
                            });
                        }}
                        store={this.formStore}
                        returnObject={true}
                        onChange={() => {
                        }}
                    /> : ''
                }

                {
                    this.formStore.getValue('level') && !IWindow.initialState.user.polling_unit_id ?
                        <>
                            {this.stateDropDown()}
                            {this.senatorialDistrictDropDown()}
                            {this.federalConstituencyDropDown()}
                            {this.formStore.getValue('level') !== 'state_constituency' ? this.lgaDropDown() : ''}
                            {this.stateConstituencyDropDown()}
                            {this.wardsDropDown()}

                        </> : ''
                }
                {
                    !IWindow.initialState.user.polling_unit_id &&
                    this.formStore.getValue('election_id') &&
                    this.formStore.getValue('candidate_id') ?
                        <Field
                            key={"form_election_polling_unit_id_" + this.formStore.getValue('election_id') +
                            this.formStore.getValue('ward_id') + this.formStore.getValue('election_position_id') 
                            + this.formStore.getValue('election_polling_unit_id') + this.formStore.getValue('local_government_area_id')
                            }
                            label={"Polling Unit"}
                            placeholder={"Polling Unit"}
                            name="election_polling_unit_id"
                            store={this.formStore}
                            component={Select}

                            loadOptions={() => {
                               return api.electionPollingUnit.getListAction({
                                    filters: {
                                        election_id: this.formStore.getValue('election_id'),
                                        ward_id: this.formStore.getValue('ward_id'),
                                        local_government_area_id : this.formStore.getValue('local_government_area_id'),
                                        election_polling_unit_id: this.formStore.getValue('election_position_id'),
                                        no_position_candidate_id: this.formStore.getValue('level') == 'polling_unit' ?
                                              this.formStore.getValue('candidate_id') : null
                                    }
                                })
                            }}
 
                            onChange={(item: any) => {
                                return api.electionPollingUnit.getVoteListAction({
                                  filters: {
                                     election_polling_unit_id : this.formStore.getValue('election_polling_unit_id'),
                                     local_government_area_id : this.formStore.getValue('local_government_area_id'),
                                     ward_id : this.formStore.getValue('ward_id'),
                                     election_id: this.formStore.getValue('election_id'),
                                   }
                                }).then((data: any) => {
                                    if(data && data.length){
                                       this.registeredVoter = data[0].registered_voters;
                                       this.formStore.setValue('number_of_votes',data[0].registered_voters);
                                       this.formStore.setValue('accredited_voters', data[0].registered_voters);
                                       this.formStore.setValue('pu_registered_voters', data[0].registered_voters);
                                       this.formStore.setValue('disputed_voters', data[0].registered_voters);
                                       // this.formStore.setValue('rejected_voters', data[0].registered_voters);
                                       
                                    }
                                });
                            }}

                        /> : ''
                }
 
                    
                
 
                  <Field
                    type="number"
                    label="Number of votes"
                    name="number_of_votes"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    min="0"
                    onChange={this.onKeyPress}
                    />
 
                <Field
                    label="Accredited voters"
                    name="accredited_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />

                <Field
                    label="Registered Voters."
                    name="pu_registered_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />

                <Field
                    label="Disputed Voters."
                    name="disputed_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />

                <Field
                    label="Rejected Voters."
                    name="rejected_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                    onChange={this.onKeyPress}
                />

                {/*<Field
                    label="Verified voters from CR."
                    name="verified_voters_from_cr"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                />

                <Field
                    label="User Defined #2"
                    name="user_defined_1"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                />

                <Field
                    label="User Defined #1"
                    name="user_defined_2"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    type="number"
                />*/}
            </>
        );
    }
}

export class ElectionPollingUnitResultFilterForm {
    @observable election_type_id = '';
    @observable election_id = '';
    @observable election_position_id = '';
    @observable party_id = '';
    @observable level = '';
    @observable state_id = '';
    @observable local_government_area_id = '';
    @observable ward_id = '';
    @observable senatorial_district_id = '';
    @observable federal_constituency_id = '';
    @observable state_constituency_id = '';
    @observable candidate_id = null;
    @observable party_competitor_party_result = 1;
    @observable user_level = IWindow.initialState.user.level;
}

export class ElectionPollingUnitResultList extends CrudList {
    modelName = 'ElectionPollingUnitResult';
    @observable candidateResult: any = null;
    @observable numberOfVotes: any = null;
    @observable level: string = '';
    @observable party_id = IWindow.initialState.user.party_id;
    @observable is_load_done: string = 'n';
    @observable is_load_done_election: string = 'n';
    @observable is_load_done_party: string = 'n';

    constructor(props: any) {
        super(props);
        this.handleExport = this.handleExport.bind(this);
        window.localStorage.setItem('election_id', '0');
    }

    stateDropDown() {
        return (!(['senatorial_district', 'federal_constituency', 'state_constituency', 'polling_unit'])
            .includes(this.filterFormStore.getValue('level'))) ?
            <Col md={2}>
                <Field
                    key={'filter_state_id_' +
                    this.filterFormStore.getValue('election_type_id') +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('party_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('candidate_id')
                    }
                    name="state_id"
                    placeholder="Select State"
                    component={Select}
                    loadOptions={() => {
                        return api.state.getListAction({
                            filters: {
                                election_id: this.filterFormStore.getValue('election_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                    [this.filterFormStore.getValue('candidate_id')] : null,
                                party_id: this.filterFormStore.getValue('party_id'),
                                user_level: this.filterFormStore.getValue('user_level')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={() => {
                        this.filterFormStore.setValue('senatorial_district_id', null);
                        this.filterFormStore.setValue('federal_constituency_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                        this.filterFormStore.setValue('state_constituency_id', null);
                        this.filterFormStore.setValue('ward_id', null);
                    }}
                />
            </Col> : '';
    };

    senatorialDistrictDropDown() {
        return this.filterFormStore.getValue('level') === 'senatorial_district' ?
            <Col md={2}>
                <Field
                    key={'filter_senatorial_district_id_' +
                    this.filterFormStore.getValue('election_type_id') +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('party_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('candidate_id')
                    }
                    name="senatorial_district_id"
                    placeholder="Select Senatorial Districts"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.senatorialDistrict.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                    [this.filterFormStore.getValue('candidate_id')] : null,
                                party_id: this.filterFormStore.getValue('party_id'),
                                user_level: this.filterFormStore.getValue('user_level')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col> : '';
    }

    federalConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'federal_constituency' ?
            <Col md={2}>
                <Field
                    key={'filter_federal_constituency_id_' +
                    this.filterFormStore.getValue('election_type_id') +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('party_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('candidate_id')
                    }
                    name="federal_constituency_id"
                    placeholder="Select Federal Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.federalConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                    [this.filterFormStore.getValue('candidate_id')] : null,
                                party_id: this.filterFormStore.getValue('party_id'),
                                user_level: this.filterFormStore.getValue('user_level')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col> : '';
    }

    lgaDropDown() { 
        return (!(['ward', 'state_constituency'])
            .includes(this.filterFormStore.getValue('level'))) ? <Col md={2}>
            <Field
                key={'filter_local_government_area_id_' +
                this.filterFormStore.getValue('election_type_id') +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('party_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('candidate_id') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('senatorial_district_id') +
                this.filterFormStore.getValue('federal_constituency_id')
                }
                name="local_government_area_id"
                placeholder="Select LGA"
                component={Select}
                loadOptions={() => {
                    return api.localGovernmentArea.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            state_id: this.filterFormStore.getValue('state_id'),
                            senatorial_district_id: this.filterFormStore.getValue('senatorial_district_id'),
                            federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                [this.filterFormStore.getValue('candidate_id')] : null,
                            party_id: this.filterFormStore.getValue('party_id'),
                            user_level: this.filterFormStore.getValue('user_level')
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={() => {
                    this.filterFormStore.setValue('ward_id', null);
                }}
            />
        </Col> : '';
    };

    stateConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'state_constituency' ?
            <Col md={2}>
                <Field
                    key={'filter_state_constituency_id_' +
                    this.filterFormStore.getValue('election_type_id') +
                    this.filterFormStore.getValue('election_id') +
                    this.filterFormStore.getValue('party_id') +
                    this.filterFormStore.getValue('election_position_id') +
                    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('candidate_id')
                    }
                    name="state_constituency_id"
                    placeholder="Select State Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.stateConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                candidateIds: this.filterFormStore.getValue('candidate_id') ?
                                    [this.filterFormStore.getValue('candidate_id')] : null,
                                party_id: this.filterFormStore.getValue('party_id'),
                                user_level: this.filterFormStore.getValue('user_level')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                    }}
                />
            </Col> : '';
    }

    wardsDropDown() {
        return <Col md={2}>
            <Field
                key={"filter_ward_id_" +
                this.filterFormStore.getValue('election_type_id') +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('party_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('candidate_id') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('senatorial_district_id') +
                this.filterFormStore.getValue('federal_constituency_id') +
                this.filterFormStore.getValue('state_constituency_id') +
                this.filterFormStore.getValue('local_government_area_id')
                }
                name="ward_id"
                placeholder="Select Ward"
                component={Select}
                loadOptions={() => {
                    return api.ward.getListAction({
                        filters: {
                            state_id : this.filterFormStore.getValue('state_id'),
                            local_government_area_id : this.filterFormStore.getValue('local_government_area_id'),
                            state_constituency_id : this.filterFormStore.getValue('state_constituency_id'),
                            election_position_id : this.filterFormStore.getValue('election_position_id'),
                            level : this.filterFormStore.getValue('level'),
                            candidateIds : this.filterFormStore.getValue('candidate_id') ?
                                [this.filterFormStore.getValue('candidate_id')] : null,
                            party_id: this.filterFormStore.getValue('party_id'),
                            user_level: this.filterFormStore.getValue('user_level'),
                            no_position: (this.filterFormStore.getValue('level') === 'polling_unit') ? 1 : null,
                        }
                    });
                }}
                store={this.filterFormStore}
            />
        </Col>;
    }

    colums() {
        return [
            {
                name: "created_user_name",
                label: "Uploaded by",
            },
            {
                name: "created_at",
                label: "Datetime",
            },
            {
                name: "polling_unit.state.name",
                label: "State",
            },
            {
                name: "polling_unit.local_government_area.name",
                label: "LGA",
            },
            {
                name: "polling_unit.ward.name",
                label: "Ward",
            },
            {
                name: "polling_unit.station_number",
                label: "PU Station",
            },
            {
                name: "polling_unit.name",
                label: "Polling Unit",
            },
            {
                name: "party_name",
                label: "Party",
            },
            {
                name: "candidate_name",
                label: "Candidate",
            },
            {
                name: "position",
                label: "Position",
            },
            {
                name: "registered_voters",
                label: "INEC Reg. Voters",
            },
            {
                name: "pu_registered_voters",
                label: "PU. Reg. Voters",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            <span
                                className={item.registered_voters && value != item.registered_voters ? 'text-danger' : ''}>{value}</span>
                        </>
                    )
                }
            },
            {
                name: "accredited_voters",
                label: "Accredited. Voters",
            },
            {
                name: "number_of_votes",
                label: "Results",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            <span className={value > item.pu_registered_voters ? 'text-danger' : ''}>{value}</span>
                        </>
                    )
                }
            },
        ];
    }

    // TODO: Module name should be dynamic
    actions() {
        return {
            name: "id",
            label: "Actions",
            formatter: (value: any, item: any) => {
                return (
                    <>
                        <HasPermission module='election_polling_unit_result' permission="edit">
                          <Button color="grid" onClick={() => this.goToDetail(item)} size="sm"
                                    className="btn-edit"><span className="icon-edit"/></Button> 
                        </HasPermission>
                    </>
                );
            },
            style: {width: 140, textAlign: 'center'},
        }
    }

    idColumn() {
        return '';
    }

    goToDetail(item: any) {
        if (item.result_id) {
            window.location.href = '/election-results/' + item.result_id;
        } else {
            window.location.href = '/election-polling-unit-detail/' + item.id;
        }

    }

    getCandidateResultDetails() {
        this.numberOfVotes = null;
        let filters = {
            ...this.filterFormStore.data
        };
        this.filterFormStore.getValue('candidate_id') && api.electionPollingUnitResult.getListAction({
            filters: filters,
            count: true
        }).then((data: any) => {
            this.numberOfVotes = data;
        })
    }

    setCandidate(candidate: any) {
        this.candidateResult = null;
        if (this.filterFormStore.getValue('candidate_id')) {
            this.candidateResult = candidate;
        } 
    }

    handleExport = () => {
        let search = {
            filters: this.filterFormStore.data,
            export: true
        };
        window.location.href = '/api/election-results?' + qs.stringify(search);
    };

    renderTable() {
        if (this.filterFormStore.getValue('election_id')) {
            return super.renderTable();
        }
        return <>{'Please select election first!'}</>;
    }

    onLoadElectionsType = () => {
        return api.electionType.getListAction({
            filters: {
               // party_id: this.filterFormStore.getValue('user_party_id'),
            }
        }).then((data: any) => {
            if (data && data.length) {
                if(this.is_load_done == "n")
                    this.filterFormStore.setValue('election_type_id', data[0].id);
            }
            this.is_load_done = "y";
            return data;
        });
    };

    onLoadElectionsData = () => {
        return api.election.getListAction({
            filters: {
                election_type_id: this.filterFormStore.getValue('election_type_id'),
                party_id: this.party_id,
            }
        }).then((data: any) => {
            if (data && data.length) {
                if(this.is_load_done_election == "n")
                    this.filterFormStore.setValue('election_id', data[0].id);
            }
            this.is_load_done_election = "y";
            return data;
        });
    };

    onLoadElectionsPartyData = () => {
        return api.party.getListAction({
            filters: {
                election_id: this.filterFormStore.getValue('election_id'),
                include_competitor_party: 1,
            }
        }).then((data: any) => {
            if (data && data.length) {
                if(this.is_load_done_party == "n")
                    this.filterFormStore.setValue('party_id', data[0].id);
            }
            this.is_load_done_party = "y";
            return data;
        });
    };

    renderFilters() {
        return (
            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
                </Row>
                <Row className="form-row">
                    <Col md={2}>
                        <Field
                            /*key={'filer-election-type' +
                            this.filterFormStore.getValue('election_type_id')
                            }*/
                            key={'filer-election-type' +
                                this.filterFormStore.getValue('election_type_id') 
                            }
                            name="election_type_id"
                            placeholder="Select Election Type"
                            component={Select}
                            required={true}
                            // loadOptions={api.electionType.getListAction}
                            loadOptions={this.onLoadElectionsType}
                            
                           /* loadOptions={() => {
                                return api.electionType.getListAction({
                                   
                                }).then((data: any) => {
                                    if (data && data.length) {
                                        // if(window.localStorage.getItem('election_typedata_id')  == "")
                                          //  this.filterFormStore.setValue('election_type_id', data[0].id);
                                    }
                                    return data;
                                });
                            }}*/
                            store={this.filterFormStore}
                            onChange={(value: any) => {
                                window.localStorage.setItem('election_typedata_id', value);
                                this.filterFormStore.setValue('election_type_id_data', value);
                                this.filterFormStore.setValue('election_id', null);
                            }}
                        />
                    </Col>

                    <Col md={2}>
                        <Field
                            // key={'filter-election' + this.filterFormStore.getValue('election_id')}
                            key={'filter' + this.filterFormStore.getValue('election_type_id')}
                            placeholder="Select Election"
                            name="election_id"
                            component={Select}
                            required={true}
                            loadOptions={this.onLoadElectionsData}
                            /*loadOptions={() => {
                                return api.election.getListAction({
                                    filters: {
                                        election_type_id: this.filterFormStore.getValue('election_type_id'),
                                        party_id: this.party_id,
                                    }
                                });
                            }}*/
                            store={this.filterFormStore}
                            onChange={(value: any) => {
                                window.localStorage.setItem('election_id', value);
                                this.filterFormStore.setValue('party_id', null);
                                this.filterFormStore.setValue('candidate_id', null);
                            }}
                        />
                    </Col>

                    {this.filterFormStore.getValue('election_id') ?
                        <Col md={2}>
                            <Field
                               /* key={'party_id_' + this.filterFormStore.getValue('election_id')} */
                               key={'filter' + this.filterFormStore.getValue('election_id')}
                                name="party_id"
                                placeholder="Select Party"
                                component={Select}
                                disabled={!this.filterFormStore.getValue('election_id')}
                                required={true}
                                // loadOptions={this.onLoadElectionsPartyData}
                                 loadOptions={() => {
                                    return api.party.getListAction({
                                        filters: {
                                            election_id: this.filterFormStore.getValue('election_id'),
                                            include_competitor_party: 1
                                        }
                                    }).then((data: any) => {
                                        return data.data;
                                    });
                                }}  
                                store={this.filterFormStore}
                                onChange={() => {
                                    this.filterFormStore.setValue('candidate_id', null);
                                    //this.filterFormStore.setValue('election_position_id', null);
                                }}
                            />
                        </Col> : ''
                    }

                    {this.filterFormStore.getValue('election_id') ?
                        <Col md={2}>
                            <Field
                                key={'election_position_id_' + this.filterFormStore.getValue('election_id') + this.filterFormStore.getValue('party_id')}
                                name="election_position_id"
                                placeholder="Select Position"
                                component={Select}
                                disabled={!this.filterFormStore.getValue('election_id')}
                                required={true}
                                loadOptions={() => {
                                    return api.electionPosition.getListAction({
                                        filters: {
                                            election_id: this.filterFormStore.getValue('election_id'),
                                            other_party_id: (this.party_id != this.filterFormStore.getValue('party_id') ?
                                                this.filterFormStore.getValue('party_id') : null),
                                            party_id: this.party_id
                                        }
                                    });
                                }}
                                returnObject={true}
                                extraKey={'level'}
                                store={this.filterFormStore}
                                onChange={(item: any) => {
                                    this.filterFormStore.setValue('level', null);
                                    if (item) {
                                        this.filterFormStore.setValue('level', item.extraKey);
                                    }
                                    this.filterFormStore.setValue('candidate_id', null);
                                    this.filterFormStore.setValue('state_id', null);
                                    this.filterFormStore.setValue('senatorial_district_id', null);
                                    this.filterFormStore.setValue('federal_constituency_id', null);
                                    this.filterFormStore.setValue('local_government_area_id', null);
                                    this.filterFormStore.setValue('state_constituency_id', null);
                                    this.filterFormStore.setValue('ward_id', null);
                                }}
                            />
                        </Col> : ''
                    }

                    {this.filterFormStore.getValue('party_id') && this.filterFormStore.getValue('election_id') ?
                        <Col md={2}>
                            <Field
                                key={'candidate_filter_election_result_' +
                                this.filterFormStore.getValue('party_id') + '_election_id' +
                                this.filterFormStore.getValue('election_id') + '_election_position_id' +
                                this.filterFormStore.getValue('election_position_id')}
                                name="candidate_id"
                                placeholder="Select Candidate"
                                component={Select}
                                disabled={!this.filterFormStore.getValue('party_id')}
                                required={true}
                                loadOptions={() => {
                                    return api.candidate.getListAction({
                                        filters: {
                                            election_id: this.filterFormStore.getValue('election_id'),
                                            party_id: this.filterFormStore.getValue('party_id'),
                                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                                        }
                                    });
                                }}
                                store={this.filterFormStore}
                                returnObject={true}
                                onChange={(candidate: any) => {
                                    this.setCandidate(candidate);
                                    this.getCandidateResultDetails();
                                }}
                            />
                        </Col> : ''
                    }

                    {
                        this.candidateResult && this.filterFormStore.getValue('candidate_id') && this.numberOfVotes ?
                        <Col md={2} key={'candidate_id_' + this.filterFormStore.getValue('candidate_id')}>
                            <div className={'form-group'}>
                                <div className={'font-weight-bold'}><span
                                    className={'icon-users'}/> {this.candidateResult.label}</div>
                                <div>
                                    Total Votes:
                                    <span className={'text-primary'}> {this.numberOfVotes}</span>
                                </div>
                            </div>
                        </Col> : ''
                    }
                </Row>

                <Row className="form-row">
                    {
                        this.filterFormStore.getValue('level') && !IWindow.initialState.user.polling_unit_id ?
                            <>
                                {this.stateDropDown()}
                                {this.senatorialDistrictDropDown()}
                                {this.federalConstituencyDropDown()}
                                {
                                    this.filterFormStore.getValue('level') !== 'state_constituency'  &&
                                    this.filterFormStore.getValue('level') !== 'polling_unit' ?
                                    this.lgaDropDown() : ''
                                }
                                {this.stateConstituencyDropDown()}
                                {this.wardsDropDown()}
                            </> : ''
                    }

                    <Col md={2} className="grid-search">
                        {this.renderSearch()}
                    </Col>
                    {this.filterFormStore.getValue('election_id') && <Col md={1} className="grid-search">
                        <button className="btn btn-dark" onClick={this.handleExport}>   </button>
                    </Col>}
                </Row>
            </Container>
        );
    }
}

export class ElectionPollingUnitResultPage extends CrudPage {
    modelName = 'ElectionPollingUnitResult';

    constructor(props: any) {
        super(props);
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ElectionPollingUnitResultPage - Copy.tsx